import { useCallback, useEffect, useState } from 'react';
import { getLocalStorage } from '../../../../utils/browserStorage';

const RECENT_SEARCHES_KEY = 'voyagerRecentSearches';
const SAVED_SEARCHES_KEY = 'voyagerSavedSearches';
const MAX_RECENT_SEARCHES = 10;

function readSearches(key: string): string[] {
  const storage = getLocalStorage();
  if (!storage) return [];

  try {
    const stored = storage.getItem(key);
    if (!stored) return [];

    const parsed = JSON.parse(stored);
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
}

export function useSearchHistory() {
  const [recentSearches, setRecentSearches] = useState<string[]>([]);
  const [savedSearches, setSavedSearches] = useState<string[]>([]);

  useEffect(() => {
    setRecentSearches(readSearches(RECENT_SEARCHES_KEY));
    setSavedSearches(readSearches(SAVED_SEARCHES_KEY));
  }, []);

  const saveToRecentSearches = useCallback((search: string) => {
    const trimmed = search.trim();
    if (!trimmed) return;

    setRecentSearches((prev) => {
      const filtered = prev.filter((s) => s !== trimmed);
      const updated = [trimmed, ...filtered].slice(0, MAX_RECENT_SEARCHES);

      const storage = getLocalStorage();
      if (storage) {
        storage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
      }

      return updated;
    });
  }, []);

  return {
    recentSearches,
    savedSearches,
    saveToRecentSearches,
  };
}
